import React, { useState } from "react";
import axios from "axios";

const FEATURE_STATUSES = [
  { value: "LIVE", label: "LIVE", color: "bg-green-100 text-green-800 border-green-300" },
  { value: "PAS_EQUIPE", label: "Pas équipé", color: "bg-gray-100 text-gray-800 border-gray-300" },
  { value: "DESEQUIPE", label: "Déséquipé", color: "bg-orange-100 text-orange-800 border-orange-300" },
  { value: "OFF", label: "OFF", color: "bg-red-100 text-red-800 border-red-300" },
];

const FeatureStatusSelector = ({ feature, status, masterId, onUpdate, token, API_URL }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [error, setError] = useState(null);

  const handleStatusChange = async (newStatus) => {
    if (newStatus === status || updating) return;

    setUpdating(true);
    setError(null);

    try {
      let endpoint;
      if (feature === "lunishower") {
        endpoint = "lunishower-status";
      } else if (feature === "greenmiles") {
        endpoint = "greenmiles-status";
      } else if (feature === "lunibutton") {
        endpoint = "lunibutton-status";
      } else {
        throw new Error("Feature inconnue");
      }
      
      const res = await axios.patch(
        `${API_URL}/hotels/${masterId}/${endpoint}`,
        { status: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data?.success === "OK") {
        setIsOpen(false);
        if (onUpdate) {
          onUpdate();
        }
      } else {
        setError(res.data?.message || "Erreur lors de la mise à jour");
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Erreur lors de la mise à jour");
    } finally {
      setUpdating(false);
    }
  };

  const currentStatus = status ? FEATURE_STATUSES.find((s) => s.value === status) : null;
  const getFeatureLabel = (feature) => {
    switch (feature) {
      case "lunishower":
        return "LuniShower";
      case "greenmiles":
        return "GreenMiles";
      case "lunibutton":
        return "LuniButton";
      default:
        return "";
    }
  };
  const featureLabel = getFeatureLabel(feature);
  const displayStatus = currentStatus || { value: null, label: "Non défini", color: "bg-gray-100 text-gray-600 border-gray-300" };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        disabled={updating}
        className={`
          inline-flex items-center gap-2 px-3 py-1.5 rounded-lg border text-sm font-medium
          transition-colors duration-200
          ${displayStatus.color}
          ${updating ? "opacity-50 cursor-not-allowed" : "hover:opacity-80 cursor-pointer"}
        `}
      >
        <span>{featureLabel}:</span>
        <span>{displayStatus.label}</span>
        {updating && <span className="animate-spin">⟳</span>}
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
          <div className="absolute z-20 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1">
            {FEATURE_STATUSES.map((statusOption) => (
              <button
                key={statusOption.value}
                type="button"
                onClick={() => handleStatusChange(statusOption.value)}
                disabled={updating || statusOption.value === status}
                className={`
                  w-full text-left px-4 py-2 text-sm transition-colors duration-150
                  ${statusOption.value === status ? "bg-blue-50 font-semibold" : "hover:bg-gray-50"}
                  ${updating ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
                `}
              >
                <div className="flex items-center gap-2">
                  <span className={`inline-block w-3 h-3 rounded-full ${statusOption.color.split(" ")[0]}`} />
                  <span>{statusOption.label}</span>
                  {statusOption.value === status && <span className="ml-auto text-blue-600">✓</span>}
                </div>
              </button>
            ))}
          </div>
        </>
      )}

      {error && (
        <div className="absolute z-30 mt-2 w-64 p-2 bg-red-50 border border-red-200 rounded text-xs text-red-700">
          {error}
        </div>
      )}
    </div>
  );
};

export default FeatureStatusSelector;
